module.exports = __webpack_public_path__ + "static/media/wallet.706f15e2.png";